import React from 'react'

import
  PropTypes
from 'prop-types';
import {
  CloseIcon,
  Container,
  FlexArticle,
  MainContainer,
  PopUpContent
} from './PopUp.styles';

import tick from '../../../images/tick.svg'
import close from '../../../images/Close.svg'
import { PrimaryButton, SmallBoldText, SmallText, XLargeBoldText } from '../input/TextField.styles';
import * as Constants from '../../../components/common/Constants';

export const PopUp = (props) => {

  const closePopUp = () => {
    props.setDisplayView({...[], currentDisplay: Constants.LOGIN});  
    props.setViewPopup('none');
  }

  return (
    <>
      {props.isChangePassword ? 
    
        <MainContainer display={props.viewPopup} >
          <Container isChangePassword={props.isChangePassword}>
            <CloseIcon>
              <span onClick={closePopUp}>
                <img width={'32px'} height={'32px'} src={close}/>
              </span>
            </CloseIcon>  
              <PopUpContent>
                <img src={tick} alt='successIcon'/>
      
                <XLargeBoldText>
                  Great news!
                </XLargeBoldText>
                <FlexArticle>
                  <SmallText color={'#525365'}>
                    {props.message}
                    
                  </SmallText>
                </FlexArticle>
                <PrimaryButton onClick={closePopUp}>
                  Log in
                </PrimaryButton>
              </PopUpContent>
              
            </Container>
        </MainContainer>
    : 
    
    <MainContainer display={props.viewPopup} >
        <Container isChangePassword={props.isChangePassword}>
          <CloseIcon>
            <span onClick={closePopUp}>
              <img width={'32px'} height={'32px'} src={close}/>
            </span>
          </CloseIcon>
    
          { props.accountType === 'gsm' ?   
            <PopUpContent>
              <img src={tick} alt='successIcon'/>
    
              <XLargeBoldText>
                Success!
              </XLargeBoldText>
              <FlexArticle>
                <SmallText color={'#525365'}>
                  Please be patient with us while we complete the verification process. <br/>
                  We have also sent an email confirming your application.<br/>
                  Enclosed is the terms and conditions that apply to access the Vodacom Converged Portal.
                </SmallText>
              </FlexArticle>
              <FlexArticle>
                <SmallText color={'#525365'} style={{ justifyContent:'center'}}>
                  Reference number: &nbsp;
                </SmallText>
                <SmallBoldText  fontSize={'16px'}>{props.refDetails.refNumber}</SmallBoldText>
              </FlexArticle>
              <FlexArticle>
                <SmallText color={'#525365'} style={{ justifyContent:'center'}}>
                  Date: &nbsp;
                </SmallText>
                <SmallBoldText  fontSize={'16px'}>{props.refDetails.submitDate}</SmallBoldText>
              </FlexArticle>
              <FlexArticle>
                <SmallText color={'#525365'}>
                  Our working hours are from Monday - Friday 08:00AM - 17:00PM <br/>
                  The verification process lead-time is 16 working hours. Contact support email
                  <SmallBoldText>msdconvergedsupport@vodacom.co.za or 082 1940</SmallBoldText>
                </SmallText>
              </FlexArticle>
              <PrimaryButton onClick={closePopUp}>
                Done
              </PrimaryButton>
            </PopUpContent>
            :
            <PopUpContent>
              <img src={tick} alt='successIcon'/>
    
              <XLargeBoldText>
                Success!
              </XLargeBoldText>
              <FlexArticle>
                <SmallText color={'#525365'}>
                  You have successfully submitted your request.
                </SmallText>
              </FlexArticle>
              <FlexArticle>
                <SmallText color={'#525365'} style={{ justifyContent:'center'}}>
                  Reference number: &nbsp;
                </SmallText>
                <SmallBoldText  fontSize={'16px'}>{props.refDetails.refNumber}</SmallBoldText>
              </FlexArticle>
              <PrimaryButton onClick={closePopUp} isChangePassword={props.isChangePassword}>
                Done
              </PrimaryButton>
            </PopUpContent>
            }
          </Container>
      </MainContainer>}
    </>
  )
};

PopUp.propTypes = {
  viewPopup : PropTypes.string,
  setviewPopup : PropTypes.func,
  refDetails: PropTypes.object,
  setRefDetails: PropTypes.func,
  accountType: PropTypes.string,
  setAccountType: PropTypes.func,
  displayView: PropTypes.string,
  setDisplayView: PropTypes.func,
  isChangePassword: PropTypes.bool  
};

PopUp.defaultProps = {
  viewPopup : '',
  setviewPopup : ()=>{},
  refDetails: {},
  setRefDetails: ()=>{},
  accountType: '',
  setAccountType: ()=>{},
  displayView: '',
  setDisplayView: ()=>{},
  isChangePassword: false
};
